import type { Status } from '@/entities/user/model/userSchema';

export const riskLevelColors: Record<string, string> = {
  Низкий: 'success',
  Средний: 'warning',
  Высокий: 'error',
  Критический: 'volcano',
};

export const measureStatusLabel: Record<Status, string> = {
  ok: 'Выполнено',
  info: 'В работе',
  warn: 'Не начато',
  err: 'Просрочено',
};

export const rowDefs = [
  { p: 5, label: 'Постоянно(5)' },
  { p: 4, label: 'Часто(4)' },
  { p: 3, label: 'Иногда(3)' },
  { p: 2, label: 'Редко(2)' },
  { p: 1, label: 'Крайне редко(1)' },
] as const;

export const colLabels = ['Незнач.', 'Лёгкая', 'Средняя', 'Тяжёлая', 'Критич.'] as const;

export const severities = [1, 2, 3, 4, 5] as const;

export const probabilitySeverityOptions = [1, 2, 3, 4, 5].map((n) => ({ value: n, label: String(n) }));

export const riskCardStatusOptions: { value: string; label: string }[] = [
  { value: 'info', label: 'Согласование' },
  { value: 'ok', label: 'Утверждена' },
  { value: 'warn', label: 'Черновик' },
];
